import React from 'react';
import { Card, CardContent, Grid, TextField, CardActions, Button, CardHeader, Typography } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import LazyBox from '../../../web/components/LazyBox';

//service
import ConfiguracaoAPI from '../../../services/api/Configuracao';

//utils
import { MaskTelefoneDefault, MaskCEP } from '../../../utils/mask';

class Configuracoes extends React.Component {
	state = {
		loading:false,
		loading_page: true,

		titulo:'',
		descricao: '',
		logradouro: '',
		bairro: '',
		cidade_uf: '',
		cep: '',
		telefone: '',
		email: '',
		loja_sabado: '',
		lazer_sabado: '',
		loja_domingo: '',
		lazer_domingo: '',

		isTitulo: false,
		isDescricao: false,
		isLogradouro: false,
		isBairro: false,
		isCidadeuf: false,
		isCep: false,
		isTelefone: false,
		isEmail: false,
		isLojaSabado: false,
		isLojaDomingo: false,
		isLazerSabado: false,
		isLazerDomingo: false,
	}

	Submit = (event) => {
		const { enqueueSnackbar } = this.props;
		event.preventDefault();
		const { titulo, descricao, logradouro, bairro, cidade_uf, cep, telefone,
				email, loja_sabado, lazer_sabado, loja_domingo, lazer_domingo } = this.state;
		event.preventDefault();
		if (titulo === '') {
			this.setState({ isTitulo: true }, () => enqueueSnackbar('Preencha o campo de titulo'));
			return;
		}
		if (descricao === '') {
			this.setState({ isDescricao: true }, () => enqueueSnackbar('Preencha o campo de descrição'));
			return;
		}
		if (logradouro === '') {
			this.setState({ isLogradouro: true }, () => enqueueSnackbar('Preencha o campo de logradouro'));
			return;
		}
		if (bairro === '') {
			this.setState({ isBairro: true }, () => enqueueSnackbar('Preencha o campo de bairro'));
			return;
		}
		if (cidade_uf === '') {
			this.setState({ isCidadeuf: true }, () => enqueueSnackbar('Preencha o campo de cidade / estado'));
			return;
		}
		if (cep === '') {
			this.setState({ isCep: true }, () => enqueueSnackbar('Preencha o campo de cep'));
			return;
		}
		if (telefone === '') {
			this.setState({ isTelefone: true }, () => enqueueSnackbar('Preencha o campo de telefone'));
			return;
		}
		if (email === '') {
			this.setState({ isEmail: true }, () => enqueueSnackbar('Preencha o campo de email'));
			return;
		}
		if (loja_sabado === '') {
			this.setState({ isLojaSabado: true }, () => enqueueSnackbar('Preencha o campo de horário de funcionamento de segunda à sabado de lojas'));
			return;
		}
		if (lazer_sabado === '') {
			this.setState({ isLazerSabado: true }, () => enqueueSnackbar('Preencha o campo de horário de funcionamento de segunda à sabado do lazer'));
			return;
		}
		if (loja_domingo === '') {
			this.setState({ isLojaDomingo: true }, () => enqueueSnackbar('Preencha o campo de horário de funcionamento no domingo de lojas'));
			return;
		}
		if (lazer_domingo === '') {
			this.setState({ isLazerDomingo: true }, () => enqueueSnackbar('Preencha o campo de horário de funcionamento no domingo do lazer'));
			return;
		}

		this.setState({ loading:true }, () => enqueueSnackbar("Aguarde salvando alterações.."));
		let forms = {
			titulo: titulo,
			descricao: descricao,
			logradouro: logradouro,
			bairro: bairro,
			cidade_uf: cidade_uf,
			cep: cep,
			telefone: telefone,
			email: email,
			loja_sabado: loja_sabado,
			lazer_sabado: lazer_sabado,
			loja_domingo: loja_domingo,
			lazer_domingo: lazer_domingo
		}

		ConfiguracaoAPI.editar(forms)
						.then(res => {
							res.json().then(res => {
								if (res.msg) {
									this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
									return;
								}
								this.setState({loading: false}, () => enqueueSnackbar('Alteração efetuada com sucesso'));
							})
						}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel salvar os dados, tente novamente mais tarde.')))

		return;
	}

	refreshConfiguracao = () => {
		const { enqueueSnackbar } = this.props;
		ConfiguracaoAPI.get()
						.then(res => {
							res.json().then(res => {
								if (res.msg) {
									this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
									return;
								}
								this.setState({
									titulo: res.titulo,
									descricao: res.meta_descricao,
									logradouro: res.logradouro,
									bairro: res.bairro,
									cidade_uf: res.cidade_uf,
									cep: res.cep,
									telefone: res.telefone,
									email: res.email,
									loja_sabado: res.func_seg_sab_loja,
									lazer_sabado: res.func_seg_sab_lazer,
									loja_domingo: res.func_domingo_loja,
									lazer_domingo: res.func_domingo_lazer,
									loading_page: false,
								})
							})
						}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel salvar os dados, tente novamente mais tarde.')))
	}

	componentDidMount(){
		this.refreshConfiguracao();
	}

    render() {
		const { titulo, descricao, logradouro, bairro, cidade_uf, cep, telefone, email, loja_sabado,
				lazer_sabado, loja_domingo, lazer_domingo, loading, isTitulo, isDescricao, isLogradouro,
				isBairro, isCidadeuf, isCep, isTelefone, isEmail, isLojaSabado, isLojaDomingo, isLazerSabado,
				isLazerDomingo, loading_page } = this.state;
        return (
				<div className="app_control__content_padding" >
					<LazyBox height="80vh" loading={loading_page} >
						<Grid container spacing={16} >
							<Grid item xs={12} >
								<form onSubmit={this.Submit} >
									<Card elevation={0} >
										<CardHeader title="Informações do site" />
										<CardContent>
											<Grid container spacing={16} >
												<Grid item xs={12} >
													<Typography variant="h6">Titulo & Meta tags</Typography>
												</Grid>
												<Grid item xs={12} >
													<TextField
														label="Titulo do site"
														placeholder="Ex: Nome do Shopping"
														value={titulo}
														error={isTitulo}
														onChange={e => this.setState({ titulo: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={12} >
													<TextField
														label="Descrição"
														placeholder="Ex: Moda, gastronomia, entretenimento, cultura, lazer e diversão. Essas e outras opções você encontra no Shopping, o melhor e mais moderno centro de compras de Minas Gerais. Com quase 400 lojas, distribuídas em quatro pavimentos, o shopping está cada dia mais incorporado à história de Belo Horizonte e à vida dos mineiros.Para agradar a toda família e os mais variados estilos, o Shopping conta com as melhores tendências e marcas, além de 10 salas de cinema, praça de alimentação com 27 operações, Espaço Gourmet e um um dos maiores centros de diversão eletrônica da América Latina. Grandes atrativos culturais, como exposições, mostras, oficinas e lançamentos de livros também fazem parte da programação do shopping"
														value={descricao}
														onChange={e => this.setState({ descricao: e.target.value })}
														margin="normal"
														error={isDescricao}
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={12} >
													<Typography variant="h6">Localização</Typography>
												</Grid>
												<Grid item xs={5} >
													<TextField
														label="Logradouro"
														value={logradouro}
														error={isLogradouro}
														onChange={e => this.setState({ logradouro: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={3} >
													<TextField
														label="Bairro"
														value={bairro}
														error={isBairro}
														onChange={e => this.setState({ bairro: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={2} >
													<TextField
														label="Cidade/UF"
														value={cidade_uf}
														error={isCidadeuf}
														onChange={e => this.setState({ cidade_uf: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={2} >
													<TextField
														label="CEP"
														value={cep}
														error={isCep}
														InputProps={{
															inputComponent:MaskCEP,
														}}
														onChange={e => this.setState({ cep: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={12} >
													<Typography variant="h6">Contato</Typography>
												</Grid>
												<Grid item xs={4} >
													<TextField
														label="Telefone"
														value={telefone}
														InputProps={{
															inputComponent: MaskTelefoneDefault,
														}}
														error={isTelefone}
														onChange={e => this.setState({ telefone: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={4} >
													<TextField
														label="Email"
														value={email}
														error={isEmail}
														onChange={e => this.setState({ email: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={12} >
													<Typography variant="h6">Funcionamento</Typography>
												</Grid>
												<Grid item xs={4} >
													<Grid container spacing={0} direction="column" >
														<Grid item xs={12} >
															<Typography variant="body1">Segunda a Sexta</Typography>
														</Grid>
														<Grid item xs={12} >
															<TextField
																label="Lojas"
																value={loja_sabado}
																error={isLojaSabado}
																onChange={e => this.setState({ loja_sabado: e.target.value })}
																margin="normal"
																variant="outlined"
																fullWidth
															/>
														</Grid>
														<Grid item xs={12} >
															<TextField
																label="Alimentação e Lazer"
																value={lazer_sabado}
																error={isLazerSabado}
																onChange={e => this.setState({ lazer_sabado: e.target.value })}
																margin="normal"
																variant="outlined"
																fullWidth
															/>
														</Grid>
													</Grid>
												</Grid>
												<Grid item xs={4} >
													<Grid container spacing={0} direction="column" >
														<Grid item xs={12} >
															<Typography variant="body1">Sábado e Domingo</Typography>
														</Grid>
														<Grid item xs={12} >
															<TextField
																label="Lojas"
																value={loja_domingo}
																error={isLojaDomingo}
																onChange={e => this.setState({ loja_domingo: e.target.value })}
																margin="normal"
																variant="outlined"
																fullWidth
															/>
														</Grid>
														<Grid item xs={12} >
															<TextField
																label="Alimentação e Lazer"
																value={lazer_domingo}
																error={isLazerDomingo}
																onChange={e => this.setState({ lazer_domingo: e.target.value })}
																margin="normal"
																variant="outlined"
																fullWidth
															/>
														</Grid>
													</Grid>
												</Grid>
											</Grid>
										</CardContent>
										<CardActions>
											<Button type="submit" variant="outlined" disabled={loading} color="primary" >Salvar</Button>
										</CardActions>
									</Card>
								</form>
							</Grid>
						</Grid>
					</LazyBox>
				</div>
        );
    }
}

export default withSnackbar(Configuracoes);



// WEBPACK FOOTER //
// ./src/painel/pages/configuracoes/index.js